const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/AppBar/DialogAppBar.tsx';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Drawer, Typography } from '@mui/material';
import { css } from '@emotion/css';
import textMap from 'App/components/AppBar/translations';
import * as React from 'react';
import { colors } from '@cistec/common_web/defs/colors';
import { theme } from 'App/utils/clientSetupManager';
import { useIntl } from 'react-intl';

interface IProps {
    isDrawerOpen: boolean;
    toggleDrawer: () => void;
    dialogOpen: boolean;
    setDialogOpen: (arg: boolean) => void;
}

const closeDrawerButtonStyle = css`
    color: ${colors.common.white};
    width: 100%;
    max-width: 500px;
`;

const dialogStyle = css`
    padding: ${theme.spacing(2)};
`;

const dialogActionStyle = css`
    padding: ${theme.spacing(1)};
`;
const drawerStyle = css`
    overflow: scroll;
`;

export const DialogsAppBar = (props: IProps) => {
    const { formatMessage } = useIntl();

    return (
        <>
            <Drawer
                anchor={'top'}
                open={props.isDrawerOpen}
                onClose={props.toggleDrawer}
                className={drawerStyle}
                variant="temporary"
                slotProps={{
                    paper: {
                        className: css`
                            padding: 5px;
                            background-color: transparent;
                            box-shadow: none;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            height: fit-content;
                            max-height: unset;
                            position: unset;
                        `,
                    },
                }}
            >
                <Button className={closeDrawerButtonStyle} variant={'text'} onClick={props.toggleDrawer}>
                    {formatMessage(textMap.Close)}
                </Button>
            </Drawer>

            <Dialog open={props.dialogOpen} onClose={() => props.setDialogOpen(false)}>
                <DialogTitle className={dialogStyle} sx={{ m: 0, p: 2 }}>
                    {formatMessage(textMap.installationProcess)}
                </DialogTitle>
                <DialogContent className={dialogStyle}>
                    <Typography>{formatMessage(textMap.iosAlert)}</Typography>
                </DialogContent>
                <DialogActions className={dialogActionStyle}>
                    <Button color="primary" onClick={() => props.setDialogOpen(false)}>
                        {formatMessage(textMap.Close)}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
